//To sorts RefinementList facets by label then by count
export const sortRefinementListFacetsByLabel = (
  a: any,
  b: any,
  alphabetically = true
) => {
  if ((a.count === 0 && b.count === 0) || (a.count !== 0 && b.count !== 0)) {
    if (a.label < b.label) {
      return alphabetically ? -1 : 1
    }
    if (a.label > b.label) {
      return alphabetically ? 1 : -1
    }
  } else {
    if (a.count < b.count) {
      return alphabetically ? 1 : -1
    }
    if (a.count > b.count) {
      return alphabetically ? -1 : 1
    }
  }
  return 0
}
